module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "invoice-area"
  }, [_c('gs-header', {
    attrs: {
      "title": ("Chi tiết phiếu chi: <span class='shipment-code-display click-copy'>" + (_vm.invoice.id) + "</span>"),
      "breadcrumbs": [{
        title: 'Quản lý phiếu chi',
        route: {
          name: 'invoice'
        }
      }]
    }
  }, [_c('el-popover', {
    ref: "confirmPopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.confirmPopup),
      callback: function($$v) {
        _vm.confirmPopup = $$v
      },
      expression: "confirmPopup"
    }
  }, [_c('p', [_vm._v("Bạn chắc chắn muốn xác nhận phiếu chi này?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.confirmPopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": !_vm.confirmPopup
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmInvoice.apply(null, arguments)
      }
    }
  }, [_vm._v("Xác\n          nhận")])], 1)]), _vm._v(" "), _c('el-popover', {
    ref: "payPopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.payPopup),
      callback: function($$v) {
        _vm.payPopup = $$v
      },
      expression: "payPopup"
    }
  }, [_c('p', [_vm._v("Bạn chắc chắn muốn thanh toán phiếu chi này?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.payPopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": !_vm.payPopup
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.payInvoice.apply(null, arguments)
      }
    }
  }, [_vm._v("Thanh\n          toán")])], 1)]), _vm._v(" "), _c('el-popover', {
    ref: "emailPopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.emailPopup),
      callback: function($$v) {
        _vm.emailPopup = $$v
      },
      expression: "emailPopup"
    }
  }, [_c('p', [_vm._v("Bạn chắc chắn muốn gửi lại email?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.emailPopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": !_vm.emailPopup
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendEmail.apply(null, arguments)
      }
    }
  }, [_vm._v("Gửi")])], 1)]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportExcel.apply(null, arguments)
      }
    }
  }, [_vm._v("Xuất excel")]), _vm._v(" "), (_vm.invoice.total_amount > 0) ? _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showpaymentExtra.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Cấn trừ")]) : _vm._e(), _vm._v(" "), (_vm.invoice.total_amount < 0 || _vm.invoice.real_amount < 0) ? _c('el-button', {
    attrs: {
      "size": "small",
      "loading": _vm.doHardPayment
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.hardPayment.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Trừ ví")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:confirmPopup",
      arg: "confirmPopup"
    }, {
      name: "show",
      rawName: "v-show",
      value: (!_vm.invoice.confirmer_id),
      expression: "!invoice.confirmer_id"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n      Xác nhận")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:payPopup",
      arg: "payPopup"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.invoice.can_payment),
      expression: "invoice.can_payment"
    }],
    attrs: {
      "type": "success",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v("\n      Thanh\n      toán")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:emailPopup",
      arg: "emailPopup"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.invoice.payer_id),
      expression: "invoice.payer_id"
    }],
    attrs: {
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" Gửi\n      email")])], 1), _vm._v(" "), (_vm.invoice.id) ? _c('div', {
    staticClass: "padding-sm-all margin-top padding-lg-bottom invoice-body"
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "border-right",
    attrs: {
      "span": 6
    }
  }, [_c('h3', [_vm._v("Thông tin shop")]), _vm._v(" "), (_vm.invoice.client) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Shop:")]), _vm._v(" "), (_vm.invoice.client.data.vip) ? _c('span', {
    staticClass: "ui label green mini"
  }, [_vm._v("Credit")]) : _c('span', {
    staticClass: "ui label grey mini"
  }, [_vm._v("Debit")]), _vm._v("\n          " + _vm._s(_vm.invoice.client.data.name) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.invoice.client) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Điện thoại:")]), _vm._v(" "), _c('span', {
    staticClass: "click-copy"
  }, [_vm._v(_vm._s(_vm.invoice.client.data.phone))])]) : _vm._e(), _vm._v(" "), (_vm.invoice.client) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('span', {
    staticClass: "click-copy"
  }, [_vm._v(_vm._s(_vm.invoice.client.data.email))])]) : _vm._e(), _vm._v(" "), (_vm.invoice.client) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Ví trả trước:")]), _vm._v(" "), _c('span', {
    staticClass: "text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.invoice.client.data.debit_amount)))])]) : _vm._e(), _vm._v(" "), (_vm.invoice.client) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Ví giao dịch:")]), _vm._v(" "), _c('span', {
    staticClass: "text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.invoice.client.data.money_amount)))])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    staticClass: "border-right",
    attrs: {
      "span": 6
    }
  }, [_c('h3', [_vm._v("Tài khoản ngân hàng")]), _vm._v(" "), (!_vm.getBankInfo.length) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.invoice.bank_info) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getBankInfo), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "margin-bottom"
    }, [_c('span', {
      staticClass: "click-copy"
    }, [_vm._v("• " + _vm._s(item.value))])])
  }), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("Lý do:")]), _vm._v(" "), _c('span', {
    staticClass: "click-copy"
  }, [_vm._v(_vm._s(_vm.getReason))])])], 2), _vm._v(" "), _c('el-col', {
    staticClass: "border-right",
    attrs: {
      "span": 6
    }
  }, [_c('h3', [_vm._v("Kiểm soát")]), _vm._v(" "), (_vm.invoice.confirmer) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Người duyệt:")]), _vm._v(" " + _vm._s(_vm.invoice.confirmer.data.name) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Duyệt lúc:")]), _vm._v(" " + _vm._s(_vm.invoice.confirmed_at))]), _vm._v(" "), (_vm.invoice.payer) ? _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Thanh toán:")]), _vm._v(" " + _vm._s(_vm.invoice.payer.data.name))]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-title-table"
  }, [_vm._v("Thanh toán lúc:")]), _vm._v(" " + _vm._s(_vm.invoice.payed_at))])]), _vm._v(" "), _c('el-col', {
    staticClass: "border-right",
    attrs: {
      "span": 6
    }
  }, [_c('h3', [_vm._v("Thanh toán")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("1. Tổng COD:")]), _vm._v(" "), (_vm.getCrossCcheckKindCod) ? _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(" " + _vm._s(_vm._f("vnd")(_vm.getTotalCOD)))]) : _vm._e(), _vm._v(" "), (_vm.getCrossCcheckKindFee || _vm.getCrossCcheckKindFee1) ? _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(" " + _vm._s(_vm._f("vnd")(0)))]) : _vm._e()]), _vm._v(" "), (_vm.getCrossCcheckKindCod) ? _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("2. Tổng phí:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.getTotalFee - _vm.getPayedFee)))])]) : _vm._e(), _vm._v(" "), (_vm.getCrossCcheckKindFee) ? _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("2. Tổng phí:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.getTotalFeeDifference)))])]) : _vm._e(), _vm._v(" "), (_vm.getCrossCcheckKindFee1) ? _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("2. Tổng phí:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.invoice.debt)))])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-bold",
    attrs: {
      "title": "Tiền cần trả shop"
    }
  }, [_vm._v("3. " + _vm._s(_vm.invoice.total_amount > 0 ? 'Trả shop' : 'Thu shop') + " "), _c('small', [_vm._v("(1-2)")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.invoice.total_amount)))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("4. " + _vm._s(_vm.invoice.money_return > 0 ? 'Truy thu' : 'Đã truy thu') + ":")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.getArearAmount)))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-bold",
    attrs: {
      "title": _vm.invoice.payment_note
    }
  }, [_vm._v("5. Nợ ví trả trước:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")((_vm.invoice.payment_extra * -1))))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "text-bold",
    attrs: {
      "title": "Tiền thực trả cho shop"
    }
  }, [_vm._v("Thực trả:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-red click-copy"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.invoice.real_amount)))])])])], 1), _vm._v(" "), (_vm.invoice.shipments) ? _c('el-row', {
    staticClass: "margin-top"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', [_vm._v("DANH SÁCH VẬN ĐƠN")]), _vm._v(" "), (_vm.getCrossCcheckKindCod) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.invoice.shipments.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mã đơn",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 2568574317)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "105"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.payer_txt) + "\n            ")]
      }
    }], null, false, 2725581541)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tài chính"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("COD: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.amount_for_cross)))])]), _vm._v(" "), _c('p', [_vm._v("Tổng phí: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Phí đã thu: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.getCompare(scope.row).last_payed_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Phí cần thu: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee - _vm.getCompare(scope.row).last_payed_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Trả shop: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.amount_return_shop + _vm.getCompare(scope.row).last_payed_fee)))])])]
      }
    }], null, false, 881170283)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí vận chuyển"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("  "), _c('span', {
          staticClass: "text-red pull-right"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.location_fee)))])]), _vm._v(" "), (scope.row.update_info_fee) ? _c('p', [_vm._v("Phí cập nhật: "), _c('span', {
          staticClass: "text-red pull-right click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.update_info_fee)))])]) : _vm._e(), _vm._v(" "), (scope.row.discount) ? _c('p', [_vm._v("Giảm giá: "), _c('span', {
          staticClass: "text-red pull-right click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.discount)))])]) : _vm._e(), _vm._v(" "), (scope.row.update_info_fee || scope.row.discount) ? _c('p', [_vm._v("Phí thực: "), _c('span', {
          staticClass: "text-red pull-right click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")((parseInt(scope.row.location_fee) +
          parseInt(scope.row.update_info_fee)) - parseInt(scope.row.discount))))])]) : _vm._e()]
      }
    }], null, false, 649544089)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Chi phí khác"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Chuyển hoàn: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.return_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Vượt cân: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.overweight_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Giao lại: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.re_delivery_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Bảo hiểm: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.insurrance_fee)))])]), _vm._v(" "), _c('p', [_vm._v("COD: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.cod_fee_real)))])]), _vm._v(" "), _c('p', [_vm._v("Phí dịch vụ: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.service_fee)))])])]
      }
    }], null, false, 42426858)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Trạng thái",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.shipmentStatuses[scope.row.status]
        }, [_vm._v(_vm._s(scope.row.status_txt))]), _c('br'), _vm._v(" "), (scope.row.is_return) ? _c('small', [_vm._v("(Chuyển hoàn)")]) : _vm._e(), _vm._v(" "), (scope.row.is_part_delivery) ? _c('small', [_vm._v("(Giao một phần)")]) : _vm._e()]
      }
    }], null, false, 1321402342)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCrossCcheckKindFee) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.invoice.shipments.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mã đơn",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 2568574317)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "105"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.payer_txt) + "\n            ")]
      }
    }], null, false, 2725581541)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Chi phí đã thu lần 1",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("  "), _c('span', {
          staticClass: "text-red pull-right"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.compare_fee.data.last_total_fee)))])])]
      }
    }], null, false, 2617603501)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí đối soát"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("  "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.compare_fee.data.total_fee)))])])]
      }
    }], null, false, 3670930480)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Chênh lệch"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.differenceFee(scope.row.compare_fee.data.last_total_fee, scope.row.compare_fee.data.total_fee))))])])]
      }
    }], null, false, 686709672)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng tiền đơn hàng"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])])]
      }
    }], null, false, 178689434)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCrossCcheckKindFee1) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.invoice.shipments.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "40"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mã đơn",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.id))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
          staticClass: "display-inline",
          attrs: {
            "placement": "top",
            "content": "Mã đơn HVC"
          }
        }, [_c('span', {
          staticClass: "shipment-code-display click-copy"
        }, [_vm._v(_vm._s(scope.row.code))])])], 1)]
      }
    }], null, false, 2568574317)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Người trả phí",
      "width": "105"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.payer_txt) + "\n            ")]
      }
    }], null, false, 2725581541)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tài chính"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Tổng phí: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Đã thu: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.getCompare(scope.row).last_payed_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Tạm thu: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.getCompare(scope.row).payed_fee)))])])]
      }
    }], null, false, 2557346471)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Phí vận chuyển"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("  "), _c('span', {
          staticClass: "text-red pull-right"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.location_fee)))])]), _vm._v(" "), (scope.row.update_info_fee) ? _c('p', [_vm._v("Phí cập nhật: "), _c('span', {
          staticClass: "text-red pull-right click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.update_info_fee)))])]) : _vm._e(), _vm._v(" "), (scope.row.discount) ? _c('p', [_vm._v("Giảm giá: "), _c('span', {
          staticClass: "text-red pull-right click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.discount)))])]) : _vm._e(), _vm._v(" "), (scope.row.update_info_fee || scope.row.discount) ? _c('p', [_vm._v("Phí thực: "), _c('span', {
          staticClass: "text-red pull-right click-copy"
        }, [_vm._v(_vm._s(_vm._f("vnd")((parseInt(scope.row.location_fee) +
          parseInt(scope.row.update_info_fee)) - parseInt(scope.row.discount))))])]) : _vm._e()]
      }
    }], null, false, 649544089)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Chi phí khác"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("Chuyển hoàn: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.return_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Vượt cân: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.overweight_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Giao lại: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.re_delivery_fee)))])]), _vm._v(" "), _c('p', [_vm._v("Bảo hiểm: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.insurrance_fee)))])]), _vm._v(" "), _c('p', [_vm._v("COD: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.cod_fee_real)))])]), _vm._v(" "), _c('p', [_vm._v("Phí dịch vụ: "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.service_fee)))])])]
      }
    }], null, false, 42426858)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Trạng thái",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.shipmentStatuses[scope.row.status]
        }, [_vm._v(_vm._s(scope.row.status_txt))]), _c('br'), _vm._v(" "), (scope.row.is_return) ? _c('small', [_vm._v("(Chuyển hoàn)")]) : _vm._e(), _vm._v(" "), (scope.row.is_part_delivery) ? _c('small', [_vm._v("(Giao một phần)")]) : _vm._e()]
      }
    }], null, false, 1321402342)
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Cấn trừ tiền COD",
      "visible": _vm.dialogPaymentExtra
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPaymentExtra = $event
      }
    }
  }, [_c('p', [_vm._v("Tác vụ này sẽ cấn trừ tiền COD của phiếu chi này và nạp số tiền đó vào ví trả trước.")]), _vm._v(" "), _c('el-form', {
    ref: "payment_extra",
    attrs: {
      "rules": _vm.rulePaymentExtra,
      "model": _vm.payment_extra,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Số tiền",
      "prop": "payment"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.payment_extra.payment),
      callback: function($$v) {
        _vm.$set(_vm.payment_extra, "payment", $$v)
      },
      expression: "payment_extra.payment"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ghi chú",
      "prop": "note"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.payment_extra.note),
      callback: function($$v) {
        _vm.$set(_vm.payment_extra, "note", $$v)
      },
      expression: "payment_extra.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingPayment
    },
    on: {
      "click": function($event) {
        return _vm.onPaymentExtra('payment_extra')
      }
    }
  }, [_vm._v("Cấn trừ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33779268"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/DetailInvoice.vue
// module id = 635
// module chunks = 1